module.exports = __webpack_public_path__ + "img/vc.cfe9e916.svg";